import codeTemplate from "/scripts/_partials/bonus/templates/code.html";
import infoTemplate from "/scripts/_partials/bonus/templates/info.html";
import applyTemplate from "/scripts/_partials/bonus/templates/apply.html";
import regTemplate from "/scripts/_partials/bonus/templates/reg.html";
import authTemplate from "/scripts/_partials/bonus/templates/auth.html";
import whatToDoTemplate from "/scripts/_partials/bonus/templates/whatToDo.html";
function bonusWhatToDoDirective() {
  return {
    restrict: 'A',
    scope: {
      page: '@',
      autorizeBonus: '&',
      changeBonus: '&',
      email: '=',
      city: '=',
      outsideName: '=?',
      outsideSurname: '=?',
      outsidePhone: '=?',
      outsidePatronymic: '=?',
      isShowPatronymic: '&',
      isApply: '&',
      bonusPlus: '@'
    },
    controller: 'BonusWhatToDoCtrl',
    controllerAs: 'bonusWhatToDo',
    bindToController: true,
    replace: true,
    templateUrl: whatToDoTemplate
  };
}
function bonusAuthDirective() {
  return {
    restrict: 'A',
    scope: {
      page: '=',
      callbackSuccess: '&',
      outsidePhone: '=?',
      enablePhoneMask: '<?'
    },
    controller: 'BonusAuthCtrl',
    controllerAs: 'bonusAuth',
    bindToController: true,
    replace: true,
    templateUrl: authTemplate
  };
}
function bonusRegDirective() {
  return {
    restrict: 'A',
    scope: {
      email: '=',
      city: '=',
      page: '=',
      outsideName: '=?',
      outsideSurname: '=?',
      outsidePhone: '=?',
      outsidePatronymic: '=?',
      isShowPatronymic: '=',
      callbackSuccess: '&',
      agreementDefaultChecked: '<?',
      enablePhoneMask: '<?'
    },
    controller: 'BonusRegCtrl',
    controllerAs: 'bonusReg',
    bindToController: true,
    replace: true,
    templateUrl: regTemplate
  };
}
function bonusApplyDirective() {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      bonusText: '=',
      changeBonus: '&',
      isApply: '='
    },
    controller: 'BonusApplyCtrl',
    controllerAs: 'bonusApply',
    bindToController: true,
    templateUrl: applyTemplate
  };
}
function bonusInfoDirective() {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      bonusData: '=',
      isShowPatronymic: '='
    },
    controller: 'BonusInfoCtrl',
    controllerAs: 'bonusInfo',
    bindToController: true,
    templateUrl: infoTemplate
  };
}
function bonusCodeDirective() {
  return {
    restrict: 'A',
    replace: true,
    scope: {},
    controller: 'BonusCodeCtrl',
    controllerAs: 'bonusCode',
    bindToController: true,
    templateUrl: codeTemplate
  };
}
export { bonusWhatToDoDirective, bonusAuthDirective, bonusRegDirective, bonusApplyDirective, bonusInfoDirective, bonusCodeDirective };